import InventoryItemDetailsPage from "./InventoryItemDetailsPage";
export default InventoryItemDetailsPage;
